import logoGuest from "@Images/logo-guest.svg";
import * as Sentry from "@sentry/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "@inertiajs/react";
import { AppLayout } from "@Layouts/AppLayout";
import { ErrorBoundaryFallback } from "@Components/ErrorBoundaryFallback";
import {
    faArrowUpRightFromSquare,
    faMoneyCheckPen,
} from "@fortawesome/pro-light-svg-icons";
import { HelpSidebar } from "@Components/HelpSidebar";

export function GuestLayout({ children }) {
    return (
        <AppLayout>
            <div className="guest-topbar">
                <nav className="bg-white border-b border-gray-100">
                    <div className="top">
                        <div className="row">
                            <div className="col-12 col-lg-4">
                                <Link href={route("welcome")}>
                                    <div className="col-6">
                                        <img
                                            className="logotype"
                                            src={logoGuest}
                                        />
                                    </div>
                                </Link>
                            </div>
                            <div className="col-12 col-lg-8 offset-lg-4 d-lg-block text-end">
                                <div className="topbar-menu-item guest me-1">
                                    <a className="menu-item" href="/pricing">
                                        <FontAwesomeIcon
                                            icon={faMoneyCheckPen}
                                            className="me-1"
                                        />{" "}
                                        Se priser
                                    </a>
                                </div>
                                <div className="topbar-menu-item d-none d-md-inline-block guest me-1">
                                    <a
                                        className="menu-item"
                                        href="https://www.akeri.se/sv"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FontAwesomeIcon
                                            icon={faArrowUpRightFromSquare}
                                            className="me-1"
                                        />{" "}
                                        akeri.se
                                    </a>
                                </div>
                                <div className="topbar-menu-item guest">
                                    <HelpSidebar
                                        title="Hjälp & Support"
                                        className="guest"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bottom"></div>
                </nav>
            </div>

            <Sentry.ErrorBoundary
                fallback={ErrorBoundaryFallback}
                beforeCapture={(scope) => {
                    scope.setTag("location", "GuestLayout");
                }}
            >
                <div className="guest-children-padding">{children}</div>
            </Sentry.ErrorBoundary>

            <div className="footer bg-dark p-3 py-lg-3">
                <div className="text-center text-white">
                    <p className="text-sm mb-0">
                        Copyright © {new Date().getFullYear()} SÅ Affärsverktyg
                        |
                        <a
                            className="text-primary"
                            href="https://greatgraphics.se"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {" "}
                            Web Master
                        </a>{" "}
                        | All Rights Reserved.
                    </p>
                </div>
            </div>
        </AppLayout>
    );
}
